export default "__VITE_PUBLIC_ASSET__ab1adf23__"